import React from 'react'
import Helmet from 'react-helmet'
import { AppContainerBase } from 'todistukset-ui/src/vtj/components/app-container/AppContainer.sc'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'

interface AppContainerProps {
  lang: LanguageCode
}

const AppContainer = ({
  lang,
  children,
}: React.PropsWithChildren<AppContainerProps>): React.JSX.Element => (
  <AppContainerBase className="app" data-test-id="app-container">
    <Helmet>
      <html lang={lang} />
    </Helmet>
    {children}
  </AppContainerBase>
)

export default AppContainer
